import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';

export const checkoutDialogOpenVar = makeVar<boolean>(false);

export function openCheckoutDialog() {
  checkoutDialogOpenVar(true);
}

export function closeCheckoutDialog() {
  checkoutDialogOpenVar(false);
}

export function useCheckoutDialogOpen() {
  return useReactiveVar(checkoutDialogOpenVar);
}
